import type { FilterPreset } from '@ipfabric/utils';
import {
  type ApiTableCommandFactory,
  advancedFilterInitialState,
} from 'components/ApiTable/model/ApiTableModel';
import { selectFilterPreset } from 'components/ApiTable/model/commands/selectFilterPreset';

interface DeleteFilterPresetCommand {
  preset: FilterPreset;
}

export const deleteFilterPreset: ApiTableCommandFactory<
  DeleteFilterPresetCommand
> = (cmdContext, dispatch) => async (command) => {
  await cmdContext.api.request({
    url: `/filters/${command.preset.id}`,
    method: 'DELETE',
  });

  cmdContext.updateState((draft) => {
    draft.advancedFilter = advancedFilterInitialState;
  });

  dispatch(selectFilterPreset, { preset: null });
};
